export const bogusWitnesses = [
  'zvzhfpblwwpobnnl',
  'zseneugtrholdevt',
  'zpohgfoicluhzyjb',
  'yotmttlqccfbrvyd',
  'yeofzmiwczqagkjx',
  'xxipvfpkkwkhgzmh',
  'xuftsksowrcllefy',
  'xtojmwgebucahpox',
  'xlfhyfliheohkedw',
  'waffleuncle',
  'vvotzjnyfoedbmvs',
  'vlzjgpfvfrnsdkxi',
  'vjmyvbdpzxzagcmp',
  'vgmjrrzuudbulsiq',
  'tbshsvloswhfzdmt',
  'ssuaqmhvophbdcki',
  'sdbahszkpkhgreuk',
  'rrwardqjsgwxmnyp',
  'rbwgoukbefkbeumm',
  'qpkjzkxmoyptiyvb',
  'pzpuslvmbbzdhncx',
  'pnrdeslenfajgfup',
  'pitwnfpedgyksbct',
  'pirfgaeaberloxbf',
  'phvddvvckilrkwzp',
  'oxduaktbectmnbty',
  'olyluligazcyfxhx',
  'ndywzqnkalzccuxd',
  'mdpstzeomhzhuunb',
  'mbirdujhnaexxszy',
  'lkfelgclvmyipsdh',
  'lgbyeanimeqqwfdn',
  'kzrjotznifuaricb',
  'khqrsmoeeyiioohs',
  'jpgwguthkckygxdp',
  'jkgjuewgetzixozv',
  'jfhkeytltceizodj',
  'iweyatphyddyoeeq',
  'ifxwktyqowkrwwrx',
  'hzhgydceniihqgqg',
  'hrhwwpfmyskjklzr',
  'gtpuyymrlybhlarn',
  'goamerica',
  'gbemyktquwtpfizr',
  'fuckchina',
  'fbhxifapkkifwtbo',
  'ezlrlgsxadllatek',
  'etdphyjyyaszohxa',
  'eqoimcbstfhdkocc',
  'emyiiwodoapkdhrr',
  'ebkdtqxbukvrovlh',
  'dvdeklepwdypbnsr',
  'dewbwllgeprbfljn',
  'ctsayghxmepazbtx',
  'bqobxklynfwjhngl',
  'boanrezckidrcacj',
  'bmfibreanioebvtr',
  'blameitonme',
  'asgxvzfnasfletar',
  'americasarmy',
  'jmbenhbazozcfuab'
]

export function isBogusWitness(name) {
    return bogusWitnesses.includes(name);
}

export function witnessFilterFunc(witnessObject) {
    return !isBogusWitness(witnessObject.owner);
}